// Central place to register DataSync per-app screen overrides.
// Add screen components under this package and register them here.
import { registerDataSyncScreens } from './DataSyncRegistry';
import {
  GoogleSheetsDataStudioSuccessScreen,
  getGoogleSheetsDataIngestionAppId,
} from './screens/GoogleSheetsDataStudioSuccessScreen';

export function initializeDataSyncRegistrations(): void {
  // Example — add overrides here:
  // import { getQboAppId } from './constants/appIds';
  // import { QboIntroScreen } from './screens/qbo/QboIntroScreen';
  // registerDataSyncScreens(getQboAppId(), {
  //   introScreen: (props) => <QboIntroScreen {...props} />,
  // });

  registerDataSyncScreens(getGoogleSheetsDataIngestionAppId(), {
    successScreen: GoogleSheetsDataStudioSuccessScreen,
  });
}

initializeDataSyncRegistrations();
